import React, { useState } from 'react';
import { Form, Radio, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const FormRadioButton = ({
  name,
  options,
  input = false,
  label,
  disabled,
  ...rest
}) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(null);
  const [customInputValue, setCustomInputValue] = useState('');

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleInputChange = (e) => {
    setCustomInputValue(e.target.value);
  };

  const allOptions = input ? [...options, { value: 'custom' }] : options;

  const finalValue =
    selectedValue === 'custom' ? customInputValue : selectedValue;

  return (
    <>
      <Form.Item {...rest} name={name} label={label} key={name}>
        <Radio.Group
          onChange={handleRadioChange}
          value={selectedValue}
          style={{ display: 'flex', flexDirection: 'column' }}
          disabled={disabled}
        >
          {allOptions.map((option) => (
            <div
              key={option.value}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Radio
                value={option.value}
                style={{ padding: '10px', fontWeight: 'normal' }}
              >
                {option.label}
              </Radio>
              {option.value === 'custom' && (
                <Input
                  placeholder={t('Napíšte vašu možnosť')}
                  value={customInputValue}
                  onChange={handleInputChange}
                  style={{ width: 200, marginLeft: -10 }}
                  disabled={selectedValue !== 'custom'}
                />
              )}
            </div>
          ))}
        </Radio.Group>
      </Form.Item>
      <Form.Item name={name} noStyle>
        <Input type="hidden" value={finalValue} />
      </Form.Item>
    </>
  );
};

export default FormRadioButton;
